const theme = {
  'globalHeader': {
    'headerIcon': 'arrowGrey',
  }
}

export { theme }